import {
  getMiddleText,
  getMiddleNumber,
  getMiddleBoolean,
  getMiddleImageSrc
} from '@fasstech/middle-client';
import middleFeaturesContext from '../context/middle-features.context.js';
import { useContext } from 'react';

export const useMiddleFeaturesContext = () => {
  return {
    middleFeatures: useContext(middleFeaturesContext),
    getMiddleText,
    getMiddleNumber,
    getMiddleBoolean,
    getMiddleImageSrc
  };
};
